import React from 'react';
import {/*Col,*/ Container} from 'reactstrap';
import Modes from "../exercises/mode/Modes";
import ModeItem from "./modeItem/ModeItem";
import {getRandomIntegerWithRange} from "../exercises/Random";
//import {formatNumberForDisplay} from "../ui/NumberFormatter";
import DebugHelperElement from "./DebugHelperElement";
//import ArithmeticElement from "./modes/ArithmeticElement";
import Keyboard from "./keyboard/Keyboard";
//import Constants from "./constants";
import "../success-checkmark.css"
import SuccessElement from "./SuccessElement";
import "../style/PracticePage.sass"
import getModesFromURL from "../ModeURLParameterHelper";

class PracticePage extends React.Component{

    constructor(props){
        super(props);
        this.modes = props.modes;
        if(props.modes.length === 0){
            //this.props.history.push("/");
            this.modes = Object.keys(getModesFromURL());
        }

        this.state = {
            modeComponent: <p>Loading</p>
        };
    }

    nextExercise = async() => {
        if(this.modes.length === 0){
            return;
        }

        const nextModeKey = this.modes[getRandomIntegerWithRange(0, this.modes.length)];
        const nextMode = Modes[nextModeKey];
        nextMode.generateExercise();

        const importedComponent = await nextMode.getComponent();

        const newState = {
            modeComponent: importedComponent,
            modeKey: nextModeKey,
            mode: nextMode,
            index: 0,
            time: new Date().getTime()
        };
        this.setState(newState);

    };

    inputRegistration = (modeComponentInputCallback)=>{
        this.modeComponentInputCallback = modeComponentInputCallback;
    };

    inputCallback = (value) => {
        this.modeComponentInputCallback(value);
    };

    componentDidMount() {
        this.nextExercise();
    }

    onInputCorrect = (index) => {
        //-1 because stepcount is not zero indexed while index is
        const stepCount = this.state.mode.getExercise().getStepCount()-1;
        if(index === stepCount){
            //Done
            this.setState({successElement: <SuccessElement/>});
            setTimeout(()=>{
                this.setState({successElement: null});
                this.nextExercise()
            }, 1200);
        }else{
            this.setState({index: index+1});
        }
    };

    render(){
        if(!this.state.mode){
            return <p>Loading</p>
        }
        return (
            <div className={"practice-page"}>
                <li className={`mode-card-practice mode-card`} >
                    <ModeItem
                        showBackButton={true}
                        key={"practice-mode-"+this.state.modeKey}
                        modeKey={this.state.modeKey}
                        mode={this.state.mode}
                        onClick={this.onModeClicked}
                        showExercise={true}
                    />
                </li>
                <Container className={"practice-page-input"}>
                    <DebugHelperElement
                        search={window.location.search}
                        mode={this.state.mode}
                        index={this.state.index}
                    />
                    {
                        this.state.successElement
                    }

                    {
                        React.createElement(
                            this.state.modeComponent.default,
                            {
                                index: this.state.index,
                                inputRegistration: this.inputRegistration,
                                mode: this.state.mode,
                                onInputCorrect: this.onInputCorrect,
                                time: this.state.time //Used to reset input fields
                            }
                        )
                    }
                </Container>
                <Keyboard
                    inputCallback={this.inputCallback}
                    mode={this.state.mode}
                    index={this.state.index}
                />
            </div>
        )
    }
}
/*
<div className={"mode-card-practice"}>111aosjudbasdb</div>
                <div className={"practice-page-input"}>2222aosjudbasdb</div>
                <div className={"keyboard-container"}>3333aosjudbasdb</div>
 */
export default PracticePage